import { comprises, opqrstToStep, sampleToStep, vitalsToStep } from "@meddbriefer/feedback-data/analysisData";
import { globalReassessmentKn, globalReassessmentFeedback, vitalsFeedback } from "@meddbriefer/feedback-data/analysisData"
import { applyFBTemplate } from "./debriefingUtils"




//events are what was observed 
//actions is the observations that have been annotated with prior analysis results
export function inferenceCheckingForAssessments(events, actions, scenName){
    let lComprises = {...comprises}
    

    for (const [id, rule] of Object.entries(lComprises)){

        let found 
        let done
        let notDone
        let numNeeded = 1
        if (rule.type === "reassessment vitals"){
            let args = globalReassessmentKn[scenName]["vitalLabels"]
            rule["args"] = args
            numNeeded = 2
        }
       
        let vitals = rule["args"]
        let translation 
        switch (rule.type) {
            case "sample":
                translation = sampleToStep
                break;
            case "opqrst":
                translation = opqrstToStep
                break;
            default:
                translation = vitalsToStep
                break;
        }
        let vitalsCount = doVitalsCounts(events,vitals,translation)

        //collect which required vitals were checked twice and which
        //were not according to the vitalsCount
        for (const [vital, count] of Object.entries(vitalsCount)){
            if (count < numNeeded){
                if (!!notDone){
                    notDone = notDone + ", " + vital}
                else {notDone = vital}}
            else {
                if (!!done){
                    done = done + ", " + vital}
                else {done = vital}
            }
        }
        

        if (!done && !!notDone){
            found = "none"
        }
        if (!!done && !notDone){
            found = "all"
        }
        if (!!done && !!notDone){
            found = "some" 
        }
        if (rule.op === "or" && found != "none"){
            found = "all"
        }

        // map loggedIDs and missingEvents to vital labels
        

         //look for the id in the rule when rule type is for reassessment-vitals or baseline-vitals 
         //because these are what we can infer fully, partially or not at all
         switch (found) {
            case "all":
                updateStatus(id, rule.type, actions, "inferred-allDone", [], done, scenName)
                break;
            case "some":
                updateStatus(id, rule.type, actions, "inferred-someDone", notDone,done,scenName)
                break;
         
            default:
                updateStatus(id, rule.type, actions, "inferred-notDone", notDone,[],scenName)
                break;
         }
         
    }
    return actions
}

function updateStatus(id, type, actions, status, notDone, done, scen){
  let actsToUpdate = actions.filter(e => e.id === id )
  actsToUpdate.forEach(act => {
    act.status = status
    act.notDone = notDone
    act.done = done
    act.vitalsStage = type
    switch (type) {
        case "reassessment vitals":
            act.vitalsFB = doVitalsReassessmentFeedback(act,status,scen)
            break;
        case "initial vitals":
            act.minVitalsFB = doVitalsFB(act,status)
            break;
        default:
            if (status === "inferred-notDone"){
                act.vitalsStageCoverage = "any"
            }
            break;
    }
    })  
}

function doVitalsReassessmentFeedback (act, status, scen){
    let entry = {...globalReassessmentKn[scen]}
    let fbTemplates = globalReassessmentFeedback   
    let finalFB
    let template 

    //save the list of what was and wasn't done two or more times
    entry.notDone = act.notDone
    entry.done = act.done
    
    switch (status) {
        case "inferred-notDone":
            template = fbTemplates["absent"]
            act.vitalsStageCoverage = "all"
            break;
        case "inferred-allDone":
            template = fbTemplates["good"]
            break;
        case "inferred-someDone":
            template = fbTemplates["errors"]
            act.vitalsStageCoverage = "some"
            break;
        default:
            template = fbTemplates["errors"]
            act.vitalsStageCoverage = "some"
            break;
    }
    
    //Fill in the template using the field values in object entry.
    //For now am not passing in c2FB (which would be arg 2 below)
    //because we didn't define this feedback at the leaf level
    finalFB = applyFBTemplate(entry,{}, template)
    return(finalFB)
    }


function doVitalsFB(act, status) {
    let fbTemplates = vitalsFeedback
    let finalFB
    let template


    switch (status) {
        case "inferred-notDone":
            template = fbTemplates["absent"]
            act.vitalsStageCoverage = "all"
            break;
        case "inferred-allDone":
            template = fbTemplates["good"]
            break;
        default:
            template = fbTemplates["errors"]
            act.vitalsStageCoverage = "some"
            break;
    }

    //Fill in the template using the field values in object entry.
    //For now am not passing in c2FB (which would be arg 2 below)
    //because we didn't define this feedback at the leaf level
    finalFB = applyFBTemplate(act, {}, template)
    return (finalFB)
}
    
export function doVitalsCounts(actions, vitalsToCheck, vitalsTranslation) {
    let vitalsCount = []
    let numVitalFound
    let actionIDs = actions.map(e => e.id)
    let numFound
    let minFound
    for (const [vital, idEntries] of Object.entries(vitalsTranslation)) {
        if (vitalsToCheck.includes(vital)) {
            numVitalFound = 0
            vitalsCount[vital] = 0
            for (let entry of idEntries) {
                minFound = 999
                //going through the "and" entries or assessment ids and assuming all must be present in 
                //same numbers to count as a complete request for the vital (e.g. asks for each "sub"
                //measure separately for some assessments)
                for (let id of entry) {
                    if (actionIDs.includes(id)) {
                        numFound = (actions.filter(action => action.id === id && action.timestamp !== -1)).length
                        if (numFound < minFound) {
                            minFound = numFound
                        }
                        if (minFound === 0) {
                            break
                        }
                    }
                    else {
                        minFound = 0
                        break
                    }
                }
                numVitalFound = numVitalFound + minFound
            }

            vitalsCount[vital] = vitalsCount[vital] + numVitalFound
        }

    }
    return vitalsCount
}

